module.exports = __webpack_public_path__ + "img/ios-at.f5b9c225.svg";